<template>
  <div
    class="plv-iar-order-list"
  >
    <div
      v-if="tabTypes.length"
      class="plv-iar-order-list__wrap"
    >
      <!-- 标签栏 -->
      <div class="plv-iar-order-list__wrap__header">
        <div
          class="plv-iar-order-list__wrap__tabs"
          @click="tabChanged"
        >
          <div
            v-for="(tabItem, tabIndex) in tabTypes"
            :key="tabIndex"
            class="plv-iar-order-list__wrap__tabs__item"
            :class="{
              'plv-iar-order-list__wrap__tabs__item--active': tabIndex === activeTabIndex
            }"
          >
            <span
              :data-index="tabIndex"
            >
              {{ iarTrans(`orderList.status.${tabItem}`) }}
            </span>
          </div>
        </div>
        <div
          class="plv-iar-order-list__wrap__tabs__under-line"
          :style="underLineStyle"
        ></div>
      </div>

      <!-- 订单列表 -->
      <template v-if="listData.contents.length">
        <div
          class="plv-iar-order-list__wrap__contents"
          ref="orderList"
          @scroll="handleScroll"
        >
          <div
            v-if="showTopLoadMore"
            class="plv-iar-order-list__load__more plv-iar-order-list__load__more--top"
          >
            {{ iarTrans('orderList.loadMore') }}
          </div>

          <div
            v-for="(contentItem, contentIndex) in listData.contents"
            :key="contentIndex"
            class="plv-iar-order-list__wrap__contents__item"
          >
            <product-card
              v-for="product in contentItem.products"
              :key="product.id"
              :data-source="product"
              in-order-theme
              @click.native="toShowDetail(contentItem.orderNo)"
            />
            <div
              class="plv-iar-order-list__wrap__contents__item__total"
            >
              <span>{{ iarTrans('orderList.amountTo') }}</span>
              <span>￥</span>
              <span>{{ contentItem.amount }}</span>
            </div>
            <div
              class="plv-iar-order-list__wrap__contents__item__status"
              :class="{
                'plv-iar-order-list__wrap__contents__item__status--noticed': isNeedNoticed(contentItem.status),
                'plv-iar-order-list__wrap__contents__item__status--in-notice': statusInNotice(contentItem.status)
              }"
            >
              <div
                class="plv-iar-order-list__wrap__contents__item__status__text"
              >
                <span>{{ iarTrans(`orderList.status.${contentItem.status}`) }}</span>
                <pay-time
                  v-if="isWaitPay(contentItem.status)"
                  :end-time="contentItem.expireTime"
                  @count-down-end="updateSomeOrderlDetail(contentItem.orderNo)"
                />
              </div>
              <div
                class="plv-iar-order-list__wrap__contents__item__status__btn"
              >
                <span
                  @click="handleOrderBtnClick(contentItem.status, contentItem.orderNo)"
                >{{ iarTrans(`orderList.statusNextStepTips.${contentItem.status}`) }}</span>
              </div>
            </div>
          </div>

          <div
            v-if="showBottomLoadMore"
            class="plv-iar-order-list__load__more plv-iar-order-list__load__more--bottom"
          >
            {{ isNoMorePage ? iarTrans('orderList.noMore') : iarTrans('orderList.loadMore') }}
          </div>
        </div>
      </template>

      <!-- 没有订单数据状态 -->
      <div
        v-else
        class="plv-iar-order-list__wrap__contents--none"
      >
        <span>{{ iarTrans('orderList.none') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import orderListMixin from './order-list-mixin';
import ProductCard from '../../components/order/ProductCard';
import PayTime from '../../components/order/PaySurplusTime';

export default {
  mixins: [orderListMixin],

  components: {
    ProductCard,
    PayTime,
  }
};

</script>

<style lang="scss">
.plv-iar-order-list, .plv-iar-order-list__wrap {
  line-height: 1.2;
  height: 100%;
}

.plv-iar-order-list__wrap {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 16px;
  font-size: 14px;
  color: #333333;
  box-sizing: border-box;

  .plv-iar-order-list__wrap__contents {
    flex: 1;
    flex-shrink: 0;
    overflow: auto;
  }

  .plv-iar-order-list__wrap__contents--none {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &::before {
      display: block;
      content: '';
      width: 65px;
      height: 67px;
      background: url('./imgs/icon-order-list-empty.png') center / 100% no-repeat;
    }

    span {
      margin-top: 16px;
      color: #999;
      font-size: 12px;
    }
  }
}

.plv-iar-order-list__wrap__header {
  padding-bottom: 16px;
}

.plv-iar-order-list__wrap__tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #999999;
}

.plv-iar-order-list__wrap__tabs__item {
  cursor: pointer;
  text-align: center;
}

.plv-iar-order-list__wrap__tabs__under-line {
  position: relative;
  width: 16px;
  height: 2px;
  margin-top: 3px;
  background: #F15D5D;
  transition: all 0.3s ease-out;
}

.plv-iar-order-list__wrap__tabs__item--active {
  color: #333333;
}

.plv-iar-order-list__wrap__contents__item {
  background: #fff;
  border-radius: 8px;
  &:not(:first-child) {
    margin-top: 8px;
  }
}

.plv-iar-order-list__wrap__contents__item__total {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 4px 16px 12px 16px;
  font-size: 18px;

  span:nth-child(1) {
    color: #999;
    font-size: 14px;
  }
}

.plv-iar-order-list__wrap__contents__item__status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px 16px 16px;

  .plv-iar-order-list__wrap__contents__item__status__text {
    span {
      color: #666;
    }
  }

  .plv-iar-order-list__wrap__contents__item__status__btn {
    border-radius: 20px;
    padding: 6px 20px;
    border: 1px solid rgba(51, 51, 51, 0.1);
  }
}

.plv-iar-order-list__wrap__contents__item__status--noticed {
  .plv-iar-order-list__wrap__contents__item__status__text {
    span {
      color: #F15D5D;
    }
  }

  .plv-iar-order-list__wrap__contents__item__status__btn {
    color: #fff;
    background: #F15D5D;
    border: 1px solid #F15D5D;
  }
}

.plv-iar-order-list__wrap__contents__item__status--in-notice {
  .plv-iar-order-list__wrap__contents__item__status__text {
    span {
      color: #F15D5D;
    }
  }
}

.plv-iar-order-list__load__more {
  width: 100%;
  text-align: center;
  color: rgba(#000000, 0.4);
}

.plv-iar-order-list__load__more--top {
  margin-bottom: 8px;
}

.plv-iar-order-list__load__more--bottom {
  margin-top: 8px;
}
</style>
